/// App backdrop - TitanX-style, two SYMMETRIC diagonal blue washes on black (founder direction
/// 2026-08-26): the SAME Horizon blue (#2F7FE3), the SAME opacity and stops, from the top-left and
/// the bottom-right, so both corners read identically. Fades to transparent by ~30% so black
/// dominates. Nothing else - no stars, no moon, no grid, no motion.

export default function SkyBackground() {
  // Purer blue: the old rgba(47,127,227) had a high green channel (G=127) that read teal/green where
  // it pooled in a corner under a panel. Lowered green so it reads as clean Horizon blue, not teal.
  const wash = 'rgba(42,96,226,0.55) 0%, rgba(42,96,226,0.16) 13%, transparent 30%'
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 0,
      overflow: 'hidden', pointerEvents: 'none',
      background:
        `linear-gradient(135deg, ${wash}),` +  // top-left
        `linear-gradient(315deg, ${wash}),` +  // bottom-right (identical blue, equal)
        '#000000',
    }} />
  )
}
